import { createFileRoute } from "@tanstack/react-router";
import { createSocialHeadMeta } from "~/lib/social-head";
import { BONDS_SOCIAL_METADATA } from "~/lib/social-metadata";
import { createRwaMarketsRouteLoader } from "~/features/rwa-markets/rwa-markets-route-loader";

export const Route = createFileRoute("/_app/bonds")({
  head: () => ({
    meta: createSocialHeadMeta(BONDS_SOCIAL_METADATA),
  }),
  loader: createRwaMarketsRouteLoader("bonds"),
});
